<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>
                Terminkorrektur
            </modal-header>
            <modal-content>
                <form-datepicker id="new_delivery_date" name="new_delivery_date" label="Korrigierter Liefertermin"
                                 v-model:date="form.new_delivery_date" :error="form.errors.new_delivery_date" @update:date="updateEditor" />

                <form-text id="comment" label="Kommentar" v-model="form.comment" :error="form.errors.comment" />
                <form-html id="text" label="Nachricht an Kunden" v-model="form.text" :error="form.errors.text" height="300px" ref="quill" />
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">Absenden</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import {useForm} from '@inertiajs/vue3';
import FormText from '@partfactory/Shared/Form/FormText';
import FormHtml from '@partfactory/Shared/Form/FormHtml';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';

export default {
    name: 'ClientLateDeliveryModal',
    components: {
        FormDatepicker,
        FormHtml, FormText, ModalContent, ModalHeader, FormButton, ModalActions, Modal},
    props: {
        askForQuote: Object,
    },
    emit: ['closeDialog'],
    data() {
        let text = null;

        const form = useForm({
            new_delivery_date: null,
            comment: null,
            text: '<p>Bitte Liefertermin aktualisieren um Nachricht zu laden.</p>',
        });

        return {form, text};
    },
    methods: {
        updateEditor(new_delivery_date) {

            if (this.askForQuote.client_user.language === 2) {
                this.$language.current = 'en';
            }

            const translated = this.$gettext('<h1>Guten Tag %{name},</h1>' +
                '<p>leider gab es bei Ihrem Auftrag <strong>%{pfnumber}</strong> (Projekttitel: %{project_name}) Probleme in der Produktion. In der Folge müssen wir Ihnen leider mitteilen, dass wir den Liefertermin nicht einhalten können.</p>'+
                '<p>Obwohl wir mit oberster Priorität an Ihrem Auftrag arbeiten, verzögert sich Ihr Liefertermin. Ihr neuer Liefertermin ist am <strong>%{delivery_date}</strong>.</p>'+
                '<p>Wir bitten um Entschuldigung.</p>');

            this.text = this.$gettextInterpolate(translated, {
                name: this.askForQuote.client_user.name,
                pfnumber: this.askForQuote.pfnumber,
                project_name: this.askForQuote.project_name,
                delivery_date: this.$moment(new_delivery_date).format('DD.MM.YYYY'),
            });

            this.$language.current = 'de';

            this.$refs.quill.updateEditor(this.text);
        },
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                    text: this.text,
                }))
                .post(this.$$route('ask-for-quote.delivery.client-late-delivery', {'askForQuote': this.askForQuote.id}), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        }
    }
};
</script>
